<script>
import ChevronDown from "../icons/ChevronDown.vue";
import SignOut from "../icons/SignOut.vue";
import User from "../icons/User.vue";

export default {
    name: "MainNavigationLeft",
    components: {User, SignOut, ChevronDown},
    data() {
        return {
            dropdown: '',
        }
    },
    mounted() {
        const self = this;
        this.$router.beforeEach((to, from, next) => {
            self.dropdown = '';
            next();
        });

        document.querySelector('main').addEventListener('click', function () {
            self.dropdown = '';
        });
    },
    methods: {
        toggleDropdown(name) {
            if (this.dropdown === name) {
                this.dropdown = '';
            } else {
                this.dropdown = name;
            }
        },
    }
}
</script>

<template>
    <nav class="hidden 2xl:block">
        <ul class="flex flex-row items-center space-x-2 sm:space-x-3 md:space-x-6" data-dropdown="false">
            <li class="relative items-center group">
                <router-link
                    :to="{name: 'order'}"
                    class="py-1.5 whitespace-nowrap text-leonard-black hover:text-leonard-green-hover"
                    active-class="text-leonard-green hover:!text-leonard-green"
                >
                    Order Photos
                </router-link>
            </li>
            <li class="relative flex items-center group flex-row" v-if="loggedIn() && isEmployee">
                <button type="button" aria-label="User Dropdown Menu" @click.prevent="toggleDropdown('employee')"
                        class="grid grid-cols-[1fr_auto] justify-between items-center w-full py-1.5 whitespace-nowrap text-leonard-black hover:text-leonard-green-hover opacity-100"
                >
                    Employees &amp; Officers
                    <ChevronDown class="text-leonard-black group-hover:text-leonard-green-hover ms-1 w-4"/>
                </button>
                <ul class="absolute left-0 top-3 mt-4 py-2 px-4 shadow-md rounded z-10 group-hover:block bg-leonard-grey"
                    :class="{'dropdown-open': dropdown === 'employee'}"
                    v-show="dropdown === 'employee'"
                >
                    <li class="relative flex items-center group flex-row">
                        <a class="grid grid-cols-[1fr_auto] justify-between items-center w-full py-1.5 whitespace-nowrap text-leonard-black hover:text-leonard-green-hover opacity-100"
                           target="_blank" rel="noopener noreferrer" title="School Administrative Portal"
                           href="https://schooladmin.leonards.com/login">
                            School Administrative Portal
                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-link ml-6">
                                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                            </svg>
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </nav>
</template>
